import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import moment from 'moment';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import {
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {},
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  textLink: {
    textDecoration: 'underline',
  },
}));

const RisksTable = props => {
  const { className, risks, ...rest } = props;

  const classes = useStyles();
  const history = useHistory();

  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(0);

  const user = useSelector((state) => state.account.user);
  const currencySymbol = (user && user.currencySymbol) ? user.currencySymbol : "$";

  const dateTimeFormat = 'DD/MM/YYYY HH:mm:ss';

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return moment(dateString).format('DD/MM/YYYY');
  };

  const formatDateTime = (timeString) => {
   
    if (!timeString) return 'N/A';
    if (typeof timeString === 'object' && '_seconds' in timeString) {
      return moment(new Date(timeString._seconds * 1000)).format(dateTimeFormat);
    }

    if (timeString && typeof timeString === 'number' && timeString.toString().length === 10) {
      // console.log('timeString', timeString, moment(new Date(Number(timeString) * 1000)).format(dateTimeFormat));
      // console.log('timeString', timeString, id);
      return moment(new Date(Number(timeString) * 1000)).format(dateTimeFormat);
     }
    return moment(timeString, dateTimeFormat).format(dateTimeFormat);
  };

  const getTimestamp = (timeString) => {
    if (!timeString) return 0;
    if (typeof timeString === 'object' && '_seconds' in timeString) {
      return timeString._seconds * 1000;
    }
    if (timeString && typeof timeString === 'number' && timeString.toString().length === 10) {
      return Number(timeString) * 1000;
    }
    return moment(timeString, dateTimeFormat).valueOf();
  };

  const openRiskDetail = (risk) => {
    history.push(`/risk/${risk.id}?year=${risk.orderYearString}`);
  };

  // Sort risks by order time in ascending order
  const sortedRisks = [...risks].sort((a, b) => {
    return getTimestamp(b.createdAt) - getTimestamp(a.createdAt);
  });

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Risk ID</TableCell>
                <TableCell>Order Number</TableCell>
                <TableCell>Risk Type</TableCell>
                <TableCell>Order Time</TableCell>
                <TableCell>Restaurant</TableCell>
                <TableCell>Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedRisks && sortedRisks.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((risk, index) => (
                <TableRow
                  className={classes.tableRow}
                  hover
                  key={risk.orderNumber || index}
                >
                  <TableCell>{risk.id || 'N/A'}</TableCell>
                  <TableCell>
                    <Button onClick={() => openRiskDetail(risk)}>
                      <div className={classes.textLink}>
                        <Typography variant="body1">{risk.orderNumber || 'N/A'}</Typography>
                      </div>
                    </Button>
                  </TableCell>
                  <TableCell>{risk.riskType || 'N/A'}</TableCell>
                  <TableCell>{formatDateTime(risk.createdAt)}</TableCell>
                  <TableCell>{risk.restaurantName || 'N/A'}</TableCell>
                  <TableCell>
                    {currencySymbol}{risk.amount ? Number(risk.amount).toFixed(2) : '0.00'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={sortedRisks?.length || 0}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[25, 50, 100]}
        />
      </CardActions>
    </Card>
  );
};

RisksTable.propTypes = {
  className: PropTypes.string,
  risks: PropTypes.array.isRequired
};

RisksTable.defaultProps = {
  risks: []
};

export default RisksTable;
